
(function(template){
define('vue!loginVueApp/pages/LoginPage',[
  'Vue',
  'helpers',
  'vue!loginVueApp/components/Input',
], function (Vue, helpers, inputField) {
  return {
    name: 'LoginPage',
    template: template,
    data: function () {
      return {
        email: '',
        password: '',
        emailExists: false,
        isValidEmail: false,
        activeTab: true,
        lastName: '',
        confirmationNum: '',
        loading: true,
        error: ''
      };
    },
    components: {
      'input-field': inputField,
    },
    methods: {
      validateEmail: function () {
        var vm = this;
        if (helpers.validEmail(this.email)) {
          vm.isValidEmail = true;
          helpers.checkEmail(this.email).then(function (isValid) {
            vm.emailExists = isValid;
          });
        } else {
          vm.isValidEmail = false;
        }
      },
      removeError: function () {
        this.error = '';
      },
      setValidEMail: function () {
        this.$store.commit('setIsValidEmail', {isValidEmail: this.email})
        app.data.validEmail = this.email;
      },
      handleLogin: function () {
        helpers.authenticateUser(this.email, this.password, 'renderLoginVue');
      },
      handleSubmit: function () {
        if (!this.password) {
          this.validateEmail();
        } else {
          this.handleLogin();
        }
      },
      showReservations: function () {
        this.activeTab = false;
      },
      showLogin: function () {
        this.activeTab = true;
      },
      handleGoogleSignin: function () {
        var vm = this;
        vm.loading = true;
        var client = window.google.accounts.oauth2.initTokenClient({
          client_id: app.customization.googleAuth.googleAuthClientID,
          scope: 'https://www.googleapis.com/auth/userinfo.profile',
          callback: function (tokenResponse) {
              vm.loading = false;
              var id_token = tokenResponse.id_token || tokenResponse.access_token || tokenResponse.credential;

              helpers.loginAuthUser(id_token, 'GOOGLE').then(function(){
                helpers.goToSplash('google')
               
              }).fail(function(error){
                  vm.error = error;
              }).always(function(){
                  vm.loading = false;
              })
          },
          error_callback: function (error) {
              vm.loading = false;
              if(error.type == 'popup_closed'){
                  vm.error = app.localization.auth.applePopupClosed;
              } else {
                  vm.error = error.message;
              }
          }                           
        });

        client.requestAccessToken();
      },
      handleFacebookSignin: function () {
        var vm = this;
        vm.loading = true;

        FB.login(
          function (response) {
            // handle the response
            if (response.status === 'connected') {
              // Logged into your webpage and Facebook.
              helpers
                .loginAuthUser(response.authResponse.accessToken, 'FACEBOOK')
                .then(function () {
                  helpers.goToSplash('facebook')
                  // Success stuff
                })
                .fail(function (error) {
                  vm.error = error;
                })
                .always(function () {
                  vm.loading = false;
                });
            } else {
              vm.error = app.localization.auth.facebookPopupClosed;
            }
          },
          { scope: 'public_profile,email' }
        );
      },
      handleAppleSignin: function () {
        var vm = this;
        vm.loading = true;

        //Listen for authorization success
        document.addEventListener('AppleIDSignInOnSuccess', function (data) {
          helpers
            .loginAuthUser(
              data.detail.authorization.id_token,
              'APPLE',
              data.detail.user
            )
            .then(function () {
              helpers.goToSplash('apple')
            })
            .fail(function (error) {
              vm.error = error;
            })
            .always(function () {
              vm.loading = false;
            });
        });

        //Listen for authorization failures
        document.addEventListener('AppleIDSignInOnFailure', function (error) {
          if (error.detail.error != 'popup_closed_by_user') {
            if (
              error.detail.error == 'user_trigger_new_signin_flow' ||
              error.detail.error == 'popup_blocked_by_browser'
            ) {
              vm.error = app.localization.auth.applePopupWindowBlocked;
            } else vm.error = error.detail.error;
          }
          vm.loading = false;
        });

        appleAuth.auth.init({
          clientId: app.customization.appleAuth.clientID,
          scope: 'name email',
          redirectURI: app.customization.appleAuth.redirectURL,
          usePopup: true, //or false defaults to false
        });

        appleAuth.auth.signIn();
      },
      searchReservation: function () {
          helpers.searchReservation(this.lastName, this.confirmationNum);
      },
      handleForgotPw: function () {
        helpers.handleForgotPw(this.email);
      },
    },
    computed: {
      showGoogleSignin: function () {
        return app.customization.googleAuth.showGoogleButton;
      },
      showFacebookSignin: function () {
        return app.customization.facebookAuth.showFacebookButton;
      },
      showAppleSignin: function () {
        return app.customization.appleAuth.showAppleButton;
      },
    },
    watch: {
      email: function () {
        var lazyValidate = _.debounce(this.validateEmail, 500);
        lazyValidate();
      },
    },
    mounted: function() {
      $('#breadcrumbs').hide();
      if(!$('.bc-background').length){
        $('#breadcrumbs').after('<div class="bc-background"></div>')
      }
    }
  };
});
})('<div class=""> <div class="login-tabs"> <button v-bind:class="{active:activeTab}" @click.prevent="showLogin">{{localization.loginVue.login}}</button> <button v-bind:class="{active:!activeTab}" @click.prevent="showReservations">{{localization.loginVue.reservation}}</button> </div> <h4 v-if="activeTab" class="login-text">{{localization.loginVue.emailPrompt}}</h4> <h4 v-if="!activeTab" class="login-text">{{localization.loginVue.findResPrompt}}</h4> <div id="login-page"> <div class="login-form-div"> <div v-if="error" v-click-outside="hide" role="alert" class="error-message"><p>{{error}}</p> <button @click.prevent="removeError" class="error-close">X</button></div> <form class="login-form" @submit.prevent="handleSubmit"> <div v-if="activeTab" class="login-input"> <div class="email-field"> <input-field :text.sync="email" id="user-email" name="user-email" type="email" :initValue="email" labelName="Email*" ></input-field> <i v-if="isValidEmail && emailExists" class="icon-ok"></i> </div> <div v-if="email && emailExists" class=""> <input-field :text.sync="password" id="password" name="password" type="password" labelName="Password" ></input-field> <div class="login-btn-div"> <button :class="!email || !password ? \'btn btn-primary disabled\' : \'btn btn-primary\'" :disabled="!email || !password" @click.prevent="handleLogin">{{localization.loginVue.loginBtn}}</button> <button :class="!email ? \'btn btn-primary disabled\' : \'btn btn-primary\'" @click.prevent="handleForgotPw">{{localization.loginVue.forgotBtn}}</button> </div> </div> <div v-else-if="isValidEmail && !emailExists" class=""> <a class="btn btn-primary pull-right" href="#/profile/create" @click="setValidEMail" >{{localization.loginVue.createAcct}}</a > </div> </div> <div v-if="!activeTab" class="reservations"> <input-field :text.sync="lastName" id="last-name" name="lastName" type="text" labelName="Last Name" ></input-field> <input-field :text.sync="confirmationNum" id="confirmation-num" name="confirmationNum" type="text" labelName="Confirmation Number" ></input-field> <button :class="!lastName || !confirmationNum ? \'btn btn-primary disabled pull-right\' : \'btn btn-primary pull-right\'" :disabled="!lastName || !confirmationNum" @click.prevent="searchReservation">{{localization.loginVue.search}}</button> </div> </form> </div> <div class="divider-line"><div class="or-text">OR</div></div> <div class="guest-logins-div"> <div class="guest-logins"> <div class="guest-login-btn"> <a class="btn btn-primary" href="#/profile/guest">{{localization.loginVue.guestAcct}}</a> </div> <div v-if="showFacebookSignin || showAppleSignin || showGoogleSignin" class="third-party-auths"> <div class="tp-text"><h3>Sign In With</h3></div> <div class="auths-div"> <div v-show="showFacebookSignin" class="fbSpaSign"> <div @click="handleFacebookSignin" id="spaFbButton" style=" background: #4267b2; color: white; text-align: center; cursor: pointer; border-radius: 0px !important; " data-max-rows="1" data-size="large" data-button-type="continue_with" data-use-continue-as="true" > <i class="fab fa-facebook-f"></i>Facebook </div> </div> <div v-show="showAppleSignin" class="appleSpaSign"> <div @click="handleAppleSignin" style="cursor: pointer" data-type="sign-in" data-color="black" class="spaAppleBtn" > <i class="fab fa-apple"></i>Apple </div> </div> <div v-show="showGoogleSignin" id="gSignInWrapper"> <div @click="handleGoogleSignin" id="googleAuthBtn" class="spaGoogleBtn" > <i class="fab fa-google"></i>Google </div> </div> </div> </div> <div class="third-party"></div> </div> </div> </div> <div class="login-instr"> <small>If you have an account, please enter your email</small> <small>If you have an account, please enter your email If your account does not exist, you have an option to create one.</small></div> </div>');
